module.exports = __webpack_public_path__ + "static/img/medium_logo1.a5112ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/medium_logo1.png
// module id = nZfB
// module chunks = 11